/**
 * c-acc.js (CW_008 / 2026-06-30 / CW_007 c-washing-label.js 汎用化)
 *
 * 汎用アコーディオン (c-acc) 開閉エンジン。
 * c-main-product / size-table / spec-table / washing-label 等 複数 block で再利用。
 *
 * 開閉アニメーション仕様:
 *   - c-washing-label.js / c-faq-list.js / footer アコーディオン と同一の一定速度 (1500 px/s)
 *   - duration は panel.scrollHeight に応じて動的計算 (0.18s 〜 0.45s)
 *
 * 期待される DOM 構造:
 *   <div class="c-acc" data-c-acc>
 *     <button class="c-acc__toggle" aria-expanded="false" data-c-acc-toggle>
 *       <span class="c-acc__heading">[Title]</span>
 *       <span class="c-acc__chevron" aria-hidden="true"><svg>icon-caret</svg></span>
 *     </button>
 *     <div class="c-acc__panel">[Content]</div>
 *   </div>
 *
 * 関連: docs/30_詳細設計/P-03_商品詳細_詳細設計.md 8.4.2 (CW_007 c-washing-label 系譜)
 */

(function () {
  'use strict';

  var SPEED_PX_PER_SEC = 1500;
  var MIN_DURATION = 0.18;
  var MAX_DURATION = 0.45;

  function calcDuration(heightPx) {
    var d = heightPx / SPEED_PX_PER_SEC;
    if (d < MIN_DURATION) return MIN_DURATION;
    if (d > MAX_DURATION) return MAX_DURATION;
    return d;
  }

  function bind(root) {
    var btn = root.querySelector('[data-c-acc-toggle]');
    var panel = root.querySelector('.c-acc__panel');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        // 閉じる: 現在の高さを設定 → 次フレームで 0 へ
        var h = panel.scrollHeight;
        var d = calcDuration(h);
        panel.style.transitionDuration = d + 's';
        panel.style.maxHeight = h + 'px';
        // force reflow
        // eslint-disable-next-line no-unused-expressions
        panel.offsetHeight;
        panel.style.maxHeight = '0';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        // 開く: scrollHeight 取得 → そこへ transition
        panel.style.maxHeight = 'none';
        var h2 = panel.scrollHeight;
        panel.style.maxHeight = '0';
        // force reflow before re-setting
        // eslint-disable-next-line no-unused-expressions
        panel.offsetHeight;
        var d2 = calcDuration(h2);
        panel.style.transitionDuration = d2 + 's';
        panel.style.maxHeight = h2 + 'px';
        btn.setAttribute('aria-expanded', 'true');

        // 開ききった後 max-height: none に解除 (動的コンテンツで再 reflow 不要にする)
        var onEnd = function (e) {
          if (e.propertyName !== 'max-height') return;
          panel.style.maxHeight = 'none';
          panel.removeEventListener('transitionend', onEnd);
        };
        panel.addEventListener('transitionend', onEnd);
      }
    });
  }

  document.querySelectorAll('[data-c-acc]').forEach(bind);
})();
